import { ROLES } from '../constant/roles-constant';

export const SECURE_ROUTES = {
    [ROLES.PHRAMA]: ['/orders'],
    [ROLES.Delivery]: ['/orders'],
    [ROLES.Doctor]: ['/orders', `/orders/order-details`],
};
